export const REGISTRATION_ROUTE_NAMES = {
  RETAILER_REGISTRATION: 'retailer-registration',
};
